import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import ServicesSection from '@/pages/home/components/ServicesSection';
import TeamSection from '@/pages/home/components/TeamSection';
import EventsSection from '@/pages/home/components/EventsSection';
import ContactSection from '@/pages/home/components/ContactSection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <TeamSection />
      <EventsSection />
      <ContactSection />
      <Footer />
    </main>
  );
}